import type { Messages } from "./types";

export const zh: Messages = {
  // chat
  "chat.send": "发送",
  "chat.input_placeholder": "输入消息，Enter 发送，Shift+Enter 换行",
  "chat.thinking": "思考过程",
  "chat.welcome_title": "选择一个 Agent 开始聊天",
  "chat.welcome_desc": "在左侧选择或创建一个 Agent",
  "chat.create_session": "请先创建会话",
  "chat.session_exited": "会话已挂起，发送消息可自动唤醒",
  "chat.you": "我",
  "chat.loading": "加载中...",
  "chat.new_content": "新内容",

  // tool
  "tool.pending": "进行中",
  "tool.completed": "已完成",
  "tool.approved": "已允许",
  "tool.denied": "已拒绝",
  "tool.approve": "允许",
  "tool.deny": "拒绝",
  "tool.done_count": "{done}/{total} 已完成",
  "tool.section_title": "工具调用",

  // approval
  "approval.title": "待审批",
  "approval.pending_count": "{n} 项待审批",

  // memory
  "memory.title": "记忆操作确认",
  "memory.save": "保存记忆",
  "memory.delete": "删除记忆",

  // todo
  "todo.title": "任务列表",
  "todo.tag": "TODO {done}/{total}",
  "todo.tooltip": "点击查看任务列表",

  // model switch
  "model.switch_title": "切换模型（仅本会话）",
  "model.adapter_type": "适配器类型",
  "model.provider": "提供商",
  "model.model": "模型",
  "model.no_provider_hint": "请先在设置中添加提供商",
  "model.loading_models": "加载模型列表...",
  "model.tooltip": "点击切换模型",

  // attachment
  "attachment.add": "添加文件",
  "attachment.voice": "语音输入（暂未开放）",

  // cost
  "cost.tpl": "💰{cost} | 总计: {totalCost} · ⏱{duration} · {pct}% ({usedTokens}/{ctxWindow})",

  // common
  "common.confirm": "确认",
  "common.cancel": "取消",

  // error
  "error.transport": "连接错误",
  "error.upload": "附件上传失败",
  "error.switch_model": "切换模型失败",
  "error.history": "加载历史消息失败",
  "error.code_block_render": "代码块渲染失败（已降级为默认显示）",
  "error.unknown": "未知错误",
};
